@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package orecompose.oreui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainFont0 {
  public val Minecraft: FontResource by 
      lazy { init_Minecraft() }
}

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Minecraft", CommonMainFont0.Minecraft)
}

internal val Res.font.Minecraft: FontResource
  get() = CommonMainFont0.Minecraft

private fun init_Minecraft(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Minecraft",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/orecompose.oreui.generated.resources/font/Minecraft.ttf", -1, -1),
    )
)
